export default __webpack_public_path__ + "static/media/stm_layout_top.9b1bfa69.svg";